module.exports = __webpack_public_path__ + "media/icons/finansowanie-menu@3x-604dda26.svg";